import { Observable } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints";
import {
  buildParamString,
  IAPICommonResponse,
  IAPIResponse,
} from "@mindmemobile/mm-shared-global";
import { IAPIInvoiceGridModel } from "../interfaces/IAPIInvoiceGridModel";
import {
  IAPICreateUpdatePayInvoiceModel,
  IAPIInvoiceDetailPageModel,
} from "../interfaces/IAPIInvoiceDetailPageModel";
import {
  IAPICreateInvoiceModel,
  IAPIPayInvoiceModel,
  IAPIUpdateInvoiceModel,
} from "../interfaces/IAPIUpsertInvoiceModel";

class InvoiceService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }
  getInvoices(
    accountId: string,
    pageNumber: number,
    pageSize: number,
    searchValue: string
  ): Observable<IAPIResponse<IAPIInvoiceGridModel[]>> {
    const params: string = buildParamString({
      accountId: accountId,
      pageNumber: pageNumber,
      pageSize: pageSize,
      searchValue: searchValue,
    });
    return this.httpService.get<IAPIResponse<IAPIInvoiceGridModel[]>>(
      url.invoices,
      params
    );
  }

  getInvoice(
    accountId: string,
    paymentId: string,
    searchValue: string
  ): Observable<IAPIResponse<IAPIInvoiceDetailPageModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      id: paymentId,
      searchValue: searchValue,
    });
    return this.httpService.get<IAPIResponse<IAPIInvoiceDetailPageModel>>(
      url.getInvoice,
      params
    );
  }

  saveInvoice(
    data: IAPICreateInvoiceModel
  ): Observable<IAPIResponse<IAPICreateUpdatePayInvoiceModel>> {
    return this.httpService.post<IAPIResponse<IAPICreateUpdatePayInvoiceModel>>(
      url.createNewInvoice,
      data
    );
  }

  updateInvoice(
    data: IAPIUpdateInvoiceModel
  ): Observable<IAPIResponse<IAPICreateUpdatePayInvoiceModel>> {
    return this.httpService.put<IAPIResponse<IAPICreateUpdatePayInvoiceModel>>(
      url.updateInvoice,
      data
    );
  }

  deleteInvoice(
    accountId: string,
    invoiceId: string
  ): Observable<IAPIResponse<IAPICommonResponse>> {
    const request = {
      accountId: accountId,
      invoiceId: invoiceId,
    };
    return this.httpService.put<IAPIResponse<IAPICommonResponse>>(
      url.deleteInvoice,
      request
    );
  }

  payInvoice(
    data: IAPIPayInvoiceModel
  ): Observable<IAPIResponse<IAPICreateUpdatePayInvoiceModel>> {
    return this.httpService.post<IAPIResponse<IAPICreateUpdatePayInvoiceModel>>(
      url.payInvoice,
      data
    );
  }

  cancelInvoice(
    accountId: string,
    invoiceId: string
  ): Observable<IAPIResponse<IAPICommonResponse>> {
    const request = {
      accountId: accountId,
      invoiceId: invoiceId,
    };
    return this.httpService.put<IAPIResponse<IAPICommonResponse>>(
      url.cancelInvoice,
      request
    );
  }
}
export default new InvoiceService();
